export const ExemptionValidationGroups = {
    CREATE: 'create',
    EDIT: 'edit',
    'EMPLOYEE-EDIT': 'employee-edit'
};